import { Card, Form, Row } from "react-bootstrap"
import { CardTable, Header, Icon, Title } from "../../components/ConsultaPadrao/components"
import { isMobileDevice } from "../../commons/utils"
import { model_grupo, model_programacao_coleta_consulta } from "../../models"
import { useEffect, useRef, useState } from "react"
import { useAuth } from "../../contexts/AuthProvider/useAuth"
import styled from "styled-components";
import { ExButton } from "../../components/ExButton"
import LoginIcon from '@mui/icons-material/Login';
import { ExSelect } from "../../components/ExSelect"

const Container = styled.div`
    background-color: white;
`
export const CredenciaisLooker = () => {
    const auth = useAuth();

    const progidRef = useRef<any>(null)

    const [query, setQuery] = useState<string>()

    async function refresh() {
        auth.get(model_grupo.api_get).then((response: any) => {

        }).catch((error: any) => {
            console.log(error);
        }).finally(() => {
        });
    }

    useEffect(() => {
        refresh();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleSubmit = (e: any) => {
        auth.get('/v1/indicadorespbiquery', { progid: progidRef.current.getValue() }).then((e: any) => {
            console.log(e.data)
            setQuery(e.data)

        });

        e.preventDefault();
        e.stopPropagation();
    };

    return (
        <>
            <CardTable className={isMobileDevice() ? "m-3 mb-4 mt-3" : "m-4 mb-4"}>
                <Card.Body className={isMobileDevice() ? "p-1" : "p-2"}>
                    <Header>
                        <Title>
                            <Icon>{model_grupo.icon}</Icon>
                            Credenciais para Looker Studio
                        </Title>
                    </Header>
                    <Form noValidate className="w-100" onSubmit={handleSubmit}>
                        <Container>
                            <h2>Informe o ID da programação:</h2>
                            {/* <Input ref={progidRef} name="progid" id="progid" type="text" label="Prog. ID" required /> */}
                            <ExSelect ref={progidRef} id='progid' label='Prog. ID' model={model_programacao_coleta_consulta} size={'lg'} />
                            <Row className="mb-2 justify-content-end m-0">
                                <ExButton type="submit" icon={<LoginIcon />} style={{ justifyContent: 'center' }} >Gerar</ExButton>
                            </Row>
                            <span style={{ whiteSpace: 'pre' }}>{query}</span>
                        </Container>
                    </Form>
                </Card.Body>
            </CardTable>
        </>
    )
}